import { useState, useEffect, useRef } from "react";
import React from 'react';
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Form,
  Col
} from "reactstrap";
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import { taskmanageService } from "../../services/taskmanageService.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import { usermanageService } from "../../services/usermanageService.js";
import Header from "components/Headers/Header.js";
import { useHistory,useParams } from "react-router-dom";

const SMEClientAdd = (props) => {
  const params = useParams();
  const user_info = JSON.parse(localStorage.getItem("user-info"));
  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
  const [clientsearch, setclientsearch] = useState('');
  const [subclient, setsubclient] = useState('');
  const [subclientlist, setsubclientlist] = useState([]);
  const [subclientOptions, setSubclientOptions] = useState([]);
  const [selectedSubclients, setSelectedSubclients] = useState([]);
  const [formInputData, setFormInputData] = useState({
    "Accounts Payable": [
      { taskType: "Purchase invoice processing", responsibility: "Yes", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Supplier statement reconciliation", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Supplier helpdesk emails", responsibility: "No", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Supplier helpdesk calls", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Payment file", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Supplier payments", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
    "Accounts Receivable": [
      { taskType: "Sales invoice processing", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Customer helpdesk emails", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Customer helpdesk calls", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Weekly update on aged receivables", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Invoices upload on finance/factoring portal", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
    "Treasury": [
      { taskType: "Bank Reconciliation", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      // { taskType: "Receipt allocation", responsibility: "", frequency: "", dueDate: "" },
      { taskType: "Credit card reconciliation", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Petty cash reconciliation", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Factoring account reconciliation", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Bank payments", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
    "Payroll": [
      { taskType: "Payroll processing", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Payroll journal posting", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Liability reconciliation", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "PAYE Payment", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Salary Payments", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Pension Payment", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
    "VAT": [
      { taskType: "VAT review", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "VAT submission", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "VAT reconciliation", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "VAT payment", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
    "Monthend / Quarterend Closure and reports": [
      { taskType: "Monthend review/checklist", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Year end checklist", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Management accounts", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Cashflow statements", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Any Other reports", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "PowerBi Dashboards", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
    "Annual filings": [
      { taskType: "Companies house filing", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Confirmation statements", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Corporation tax submission", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      { taskType: "Personal tax submission", responsibility: "", frequency: "", dueDate: "",assign_tm_id:"" },
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
    "Calls": [
      { taskType: "Weekly catch-up calls", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Governance calls", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      { taskType: "Financial overview", responsibility: "", frequency: "", dueDate: "" ,assign_tm_id:""},
      // { taskType: "Other tasks", responsibility: "", frequency: "", dueDate: "" },
    ],
  });
  console.log(formInputData['Accounts Payable'].length)
  const [accountbox, setAccountBox] = useState(0);
  const [disablestate, setdisablestate] = useState(false);
  const [inputFields, setInputFields] = useState({
    frequency: '',
    freq_date: [],
    freq_day: '',
  });
  // const [weeklydiv, setweeklydiv] = useState(false);
  // const [annuallydiv, setannuallydiv] = useState(false);
  // const [freqdata, setfreqdata] = useState([]);

  const [frequencyStates, setFrequencyStates] = useState({});

  useEffect(() => {
    get_unique_companieslist();
    assignTMuser();
    if (params.client_id !== 'undefined' && params.client_id !== undefined) {
      getTransitionData(params.client_id);
    }

  }, []);
  const [ assignuserlist, setassignuserlist ] = useState([])
  function assignTMuser() {
    usermanageService.get_TM_user().then((response) => {
      setassignuserlist(response.data);
    });
  }
  const get_unique_companieslist = () => {
    clientmanageService.getuniqueclient().then((response) => {
      setUniqueCompaniesData(response.data);
    });
  };

  const getTransitionData = (clientname = '') => {
    clientmanageService.gettransitionData(clientname).then((response) => {
      if (response.status === 200) {
        // Assuming response.data is the form details
        setFormInputData(response.data.map(task => ({ ...task, frequency: '', dueDate: '' }))); // Initialize inputs
      } else {
        toast.error('Something went wrong!');
      }
    });
  };

  const setclient = (e) => {
    setSelectedSubclients([])
    setclientsearch(e.value);
    subclientList(e.label);
  };
  

  const subclientList = (clientname = '') => {
    clientmanageService.getsubclientlist(clientname).then((response) => {
      if (response.status === 200) {
        const subclientOptions = response.data.map(res => ({
          value: res.sub_client,
          label: res.sub_client
        }));
        setSubclientOptions(subclientOptions);
      } else {
        toast.error('Something went wrong!');
      }
    });
  };
  
  const handleInputChange = (category, index, field, value) => {
    console.log('value',value)
    console.log(field)
    const updatedInputs = { ...formInputData };
    
    updatedInputs[category] = [...updatedInputs[category]];
    if(field=='responsibility'){
      let cond = value=='No' ? true : false;
      updatedInputs[category][index]['applicable_cond'] = cond;
    }
    if (field === 'freq_date') {
      // If multi-select, extract 'value' from each selected object
      const freqValues = Array.isArray(value)
        ? value.map((option) => option.value) // Map to values if multiple
        : value?.value; // Otherwise, take single value
  
      // Set freq_date as an array, even if there's only one item for consistency
      updatedInputs[category][index][field] = Array.isArray(freqValues)
        ? freqValues
        : [freqValues];
    } else {
      // Handle other fields as usual
      updatedInputs[category][index][field] = value;
    }
  
    if (field === 'frequency') {
      const newFrequencyStates = { ...frequencyStates };

      if (!newFrequencyStates[category]) {
        newFrequencyStates[category] = [];
      }
      
      let freqdata = [];
  
      if (value !== 'OneOff') {
        if (value === 'Weekly') {
          freqdata = [
            { value: 1, label: 'Monday' }, { value: 2, label: 'Tuesday' },
            { value: 3, label: 'Wednesday' }, { value: 4, label: 'Thursday' },
            { value: 5, label: 'Friday' }, { value: 6, label: 'Saturday' },
            { value: 7, label: 'Sunday' }
          ];
          newFrequencyStates[category][index] = { ...newFrequencyStates[category][index], weekly: true, annually: false, freqdata };
        } else if (value === 'Monthly' || value === 'Fortnightly') {
          freqdata = [...Array(31)].map((_, i) => ({ value: (i + 1).toString().padStart(2, '0'), label: (i + 1).toString() }));
          newFrequencyStates[category][index] = { ...newFrequencyStates[category][index], weekly: true, annually: false, freqdata };
        } else if (['Quarterly', 'Annually', 'Bimonthly', 'Fourthmonthly'].includes(value)) {
          freqdata = [
            { value: '01', label: 'Jan' }, { value: '02', label: 'Feb' },
            { value: '03', label: 'March' }, { value: '04', label: 'April' },
            { value: '05', label: 'May' }, { value: '06', label: 'June' },
            { value: '07', label: 'July' }, { value: '08', label: 'Aug' },
            { value: '09', label: 'Sept' }, { value: '10', label: 'Oct' },
            { value: '11', label: 'Nov' }, { value: '12', label: 'Dec' }
          ];
          newFrequencyStates[category][index] = { ...newFrequencyStates[category][index], weekly: false, annually: true, freqdata };
        }else{
          newFrequencyStates[category][index] = { weekly: false, annually: false, freqdata: [] };
        }
      } else {
        newFrequencyStates[category][index] = { weekly: false, annually: false, freqdata: [] };
      }
  
      setFrequencyStates(newFrequencyStates);
      console.log('sad',newFrequencyStates)
    }
    
    setFormInputData(updatedInputs);
  };

  const addsopform = (e) => {
    e.preventDefault();
    const dataToSend = {
      client: clientsearch,
      subClients: selectedSubclients.map(sc => sc.value),
      tasks: Object.entries(formInputData).flatMap(([category, tasks]) =>
        tasks.map(task => ({
          category,
          taskType: task.taskType,
          responsibility: task.responsibility,
          frequency: task.frequency,
          dueDate: task.dueDate,
          budget: task.budget,
          freq_day: task.freq_day || '',
          day: task.day || '',
          freq_date: task.freq_date || [],
          sop_process: task.sop_process,
          assign_tm_id: task.assign_tm_id,
          department: task.department,
        }))
      )
    };

    clientmanageService.addscopeofwork(dataToSend).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message);
        // location.reload();
      }else{
        toast.error(response.data.message);
      }
      setdisablestate(false);
    });
  };

  const handleSubclientChange = (selectedOptions) => {
    // When multiple sub-clients are selected
    console.log(selectedOptions)
    setSelectedSubclients(selectedOptions || []);
  };
  const history = useHistory();
  const editData =  ()=>{
    history.push({
      pathname: `smeclientedit`,
    });
  }
  const addbox = (category)=>{
    
  const updatedInputs = { ...formInputData };  
  if (!updatedInputs[category]) {
    updatedInputs[category] = [];
  }

  updatedInputs[category].push({
    taskType: '',
    responsibility: '',
    frequency: '',
    dueDate: '',
    editable:true
  });

  setFormInputData(updatedInputs); 
  }
console.log(frequencyStates)
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
      <Row>
          
        <Col xl="2">
        <Button
          className="col-12 phase-button qatl-main-btn qatl-main-btn-sec"
          color="light"
          type="button"
          onClick={() => editData()}
        >
        {" "}
        + Edit Client{" "}
        </Button>
      </Col> 
      
      </Row>
        <Row className="mt-12">
          <div className="col" style={{ padding: '0%' }}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="filter" style={{ padding: '0 1%' }}>
                  <div className="filter" style={{ width: '80%' }}>
                    <div className="col-xl-6 col-md-6 col-xs-12">
                      <h3 className="clientformtag"> Client</h3>
                      <Select
                        className="input-group-alternative mb-3"
                        name="user_id"
                        options={uniquecompanieslist}
                        onChange={(e) => { setclient(e) }}
                        defaultValue={clientsearch}
                        searchable
                        isClearable={false}
                      />
                    </div>
                    {/* <div className="col-xl-6 col-md-6 col-xs-12">
                      <h3 className="clientformtag">Sub Client</h3>
                      <select className="form-control" name="sub_client" onChange={(e) => setsubclient(e.target.value)}>
                        <option value=""> Select Sub Client</option>
                        {subclientlist.map(res => (
                          <option key={res.sub_client} value={res.sub_client}>
                            {res.sub_client}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    <div className="col-xl-6 col-md-6 col-xs-12">
                      <h3 className="clientformtag">Sub Client</h3>
                      <Select
                        className="input-group-alternative mb-3"
                        name="sub_client"
                        options={subclientOptions}
                        value={selectedSubclients}
                        onChange={handleSubclientChange}
                        isMulti
                        placeholder="Select Sub Clients"
                      />
                    </div>
                  </div>
                </Row>
              </CardHeader>
            </Card>
          </div>
        </Row>
        <Row className="mt-12">
          <Card className="shadow" style={{ width: "100%" }}>
          <Form role="form" id="phase-selection-form" onSubmit={addsopform}>
              {Object.entries(formInputData).map(([category, tasks]) => (
                <div key={category}>
                  <br></br>
                  <h3>{category}</h3>
                  
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th className="whitespace">Sr.No.</th>
                        <th className="whitespace">Tasks Type</th>
                        <th className="whitespace">Applicable</th>
                        {/* {!applicable_cond && ( */}
                        <>
                          <th className="whitespace">Frequency</th>
                          <th className="whitespace">Fixed Budget</th>
                          <th className="whitespace">SOP Process</th>
                          <th className="whitespace">Assign TM</th>
                          <th className="whitespace">Department</th>
                        </>
                        {/* )} */}
                        {/* <th className="whitespace">Due Date</th> */}
                        {/* <th className="whitespace">Budget Type</th> */}
                       
                      </tr>
                    </thead>
                    <tbody>
                      {tasks.map((task, index) => (
                        <tr key={index} className={((index % 2 == 0)? 'blue-row':(index % 3 == 0)?'purple-row':'orange-row') } >
                          <td className="whitespace">{index + 1}</td>
                          {!task.editable ? 
                          <td className="whitespace">{task.taskType} </td>
                          :
                        <td>
                          <input
                            className="form-control"
                              type="text"
                              value={task.taskType}
                              onChange={(e) => handleInputChange(category, index, 'taskType', e.target.value)}
                              placeholder="taskType"
                            />
                        </td>}
                         
                          <td className="whitespace">
                            <select className="form-control" onChange={(e) => handleInputChange(category, index, 'responsibility', e.target.value)} >
                              <option value="">Select</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </td>
                          
                           
                          <td className="whitespace">
                          {!task.applicable_cond && ( 
                              <select class="form-control"  onChange={(e) => handleInputChange(category, index, 'frequency', e.target.value)} >
                                <option value=""> Select frequency</option>
                                <option value="OneOff">One Off</option>
                                <option value="Daily">Daily</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Fortnightly">Fortnightly</option>
                                <option value="Quarterly">Quarterly</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Annually">Annually</option>
                                <option value="Bimonthly">Bimonthly</option>
                                <option value="Fourthmonthly">Fourthmonthly</option>
                              </select>
                               )} 
                            {frequencyStates[category]?.[index]?.weekly && (
                              <div className="mt-2">
                                <label>Frequency values</label>
                                <Select
                                  className="input-group-alternative mb-3"
                                  name="freq_day"
                                  options={frequencyStates[category][index].freqdata}
                                  value={formInputData[category][index].freq_day || ''}
                                  onChange={(selected) => handleInputChange(category, index, 'freq_day', selected)}
                                  isClearable
                                  isMulti
                                  required
                                />
                              </div>
                            )}

                            {frequencyStates[category]?.[index]?.annually && (
                                <div className="mt-2">
                                 
                                      <label>Day</label>
                                      <select
                                        className="form-control"
                                        name="freq_day"
                                        value={formInputData[category][index].freq_day || ''}
                                        onChange={(e) => handleInputChange(category, index, 'freq_day', e.target.value)}
                                        required
                                      >
                                        <option value="">Select Day</option>
                                        {Array.from({ length: 31 }, (_, i) => (
                                          <option key={i + 1} value={(i + 1).toString().padStart(2, '0')}>
                                            {i + 1}
                                          </option>
                                        ))}
                                      </select>
                                    
                                      <label>Months</label>
                                      <Select
                                        className="input-group-alternative mb-3"
                                        name="freq_date"
                                        allowSelectAll={true}
                                        value={
                                          Array.isArray(formInputData[category][index].freq_date)
                                            ? frequencyStates[category][index].freqdata.filter(obj =>
                                                formInputData[category][index].freq_date.includes(obj.value)
                                              )
                                            : []
                                        }
                                        options={frequencyStates[category][index].freqdata}
                                        onChange={(selected) =>
                                          handleInputChange(category, index, 'freq_date', selected)
                                        }
                                        isMulti
                                    isClearable
                                      />
                                    
                                </div>
                              )}
                              
                          </td>
                          <td className="whitespace">
                          {!task.applicable_cond && ( 
                            <input
                            className="form-control"
                              type="number"
                              value={task.budget}
                              onChange={(e) => handleInputChange(category, index, 'budget', e.target.value)}
                              placeholder="Budget"
                            />
                          )} 
                          </td>
                          <td className="whitespace">
                          
                            <input
                            className="form-control"
                              type="text"
                              value={task.sop_process}
                              onChange={(e) => handleInputChange(category, index, 'sop_process', e.target.value)}
                              placeholder="SOP Process"
                            />
                     
                          </td>
                          <td>
                          <Select 
                   
                          className="input-group-alternative mb-3" 
                          name="assign_tm_id"
                          options={assignuserlist} // set list of the data
                          onChange={(e) => { handleInputChange(category, index, 'assign_tm_id', e.value)}}
                         
                          searchable
                          isClearable={false}
                        />
                          </td>
                        
                         <td className="whitespace">
                            <select
                              className="form-control"
                              value={task.department}
                              onChange={(e) => handleInputChange(category, index, 'department', e.target.value)}
                            >
                              <option value="SME">SME</option>
                              <option value="BookKeeping">BookKeeping</option>
                            </select>
                          </td>
                          
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <Col md="12" style={{marginTop:"10px"}}>
                  <a className="btn btn-info"  onClick={(e) => addbox(category)}>+ Add </a>
                  </Col>
                </div>
              ))}
              <br />
              <div className="d-flex">
                <Button color="primary" className="col-xl-2" style={{ flex: "0 0 4.66667%" }} type="submit">
                  Save
                </Button>
              </div>
            </Form>
          </Card>
        </Row>
      </Container>
    </>
  );
};

export default SMEClientAdd;
